import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { LoginForm, ResetPasswordBodyType } from '@core/types/login.type';
import { InjectableApi } from '@shared/decorators';
import { ApiService } from '@shared/services';
import { ForceAny } from '@shared/types';

import { Observable } from 'rxjs';

@InjectableApi({ baseSegment: '', providedIn: 'root' })
export class AuthApiService extends ApiService {
  storeToken(tokens: { accessToken?: string; refreshToken?: string }): void {
    if (tokens.accessToken)
      localStorage.setItem('X-Access-Token', tokens.accessToken);
    if (tokens.refreshToken)
      localStorage.setItem('X-Refresh-Token', tokens.refreshToken);
  }

  /**
   * @function login To login the user.
   * @param loginParams Data for login.
   * @returns An Observable with the full HttpResponse to access headers.
   */
  login(
    isSSO: boolean,
    endPoint: string,
    loginParams: LoginForm,
  ): Observable<HttpResponse<ForceAny>> {
    if (isSSO) {
      return this.headersPostRequest('/user/login', { ...loginParams });
    } else {
      return this.headersPostRequest(endPoint, { ...loginParams });
    }
  }

  /**
   * @function login To login the user.
   * @param loginParams Data for login.
   * @returns An Observable with the full HttpResponse to access headers.
   */
  logout() {
    this.version = 'v1';
    return this.post('/user/logout', {});
  }

  verifyAuthToken() {
    const token = localStorage.getItem('X-Access-Token');
    const headers = new HttpHeaders({
      Authorization: `${token}`,
    });
    return this.post('/user/verify-token', {}, headers);
  }

  savePassword(body: ResetPasswordBodyType): Observable<ForceAny> {
    const token = localStorage.getItem('X-Access-Token');
    const headers = new HttpHeaders({
      Authorization: `${token}`,
    });

    return this.post('/user/save-password', body, headers);
  }

  thirdPartySavePassword(newPassword: string): Observable<ForceAny> {
    const token = localStorage.getItem('X-Access-Token');
    const headers = new HttpHeaders({
      Authorization: `${token}`,
    });

    return this.post(
      '/user/third-party-user/save-password',
      { newPassword },
      headers,
    );
  }
}
